import {
  Box,
  Button,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import theme from "../../theme";
import { Container } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import sfLogo from "../../assets/icons/logologin.png";
import useForgotPassword from "../../hooks/useForgotPassword";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.lightGray2,
    borderColor: "transparent",
    display: "grid",
    placeItems: "center",
  },
  paper: { backgroundColor: "white", borderRadius: 8, width: 458, height: 585 },
  button: {
    marginTop: 10,
    boxSizing: "border-box",
    width: 352,
    height: 49,
    fontSize: 18,
  },
  alignCenterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  sfLogo: {
    width: 200,
    height: 86,
    marginTop: 55,
  },
  forgotPasswordText: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.orange,
    marginTop: 40,
    width: 352,
    boxSizing: "border-box",
  },
  textUnderForgotPasswordText: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 14,
    color: theme.darkGray,
    width: 352,
    boxSizing: "border-box",
  },
  helperText: {
    margin: 0,
    paddingTop: 2,
    textAlign: "right",
    fontSize: 12,
    color: theme.red,
  },
  resendButton: { fontSize: 18, marginTop: 10, color: theme.darkGray },
  backIcon: { margin: "30px 30px 0 30px" },
}));
function InputOTP() {
  const [otp, setOTP] = useState("");
  const [errorTextField, setErrorTextField] = useState(false);
  const classes = useStyles();
  const { forgotPassword, submitOTP } = useForgotPassword();
  const location = useLocation();
  const history = useHistory();
  const translate = useTranslate();
  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.allContainer}>
        <Box className={classes.alignCenterContainer}>
          <Box className={classes.paper}>
            <IconButton
              classes={{ root: classes.backIcon }}
              onClick={() => history.goBack()}
            >
              <ArrowBackIosIcon />
            </IconButton>

            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={sfLogo} alt="sflogo" className={classes.sfLogo} />

              <Typography className={classes.forgotPasswordText} align="left">
                {translate("ra.text.forgotPassword.sentOtp")}
              </Typography>

              <Typography
                className={classes.textUnderForgotPasswordText}
                align="left"
              >
                {`${translate("ra.text.forgotPassword.enterOtpRecvivedVia")} ${
                  location.state.maskedEmail
                }`}
              </Typography>

              <TextField
                id="standard-basic"
                placeholder="OTP 6-digits"
                error={errorTextField}
                helperText={
                  errorTextField
                    ? translate("ra.text.forgotPassword.otpError")
                    : ""
                }
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
                style={{
                  marginTop: 10,
                  boxSizing: "border-box",
                  width: 352,
                }}
                variant="outlined"
                onChange={(e) => setOTP(e.target.value)}
              />
              <br />

              <Button
                variant="contained"
                color="primary"
                disabled={otp.length > 5 ? false : true}
                className={classes.button}
                onClick={async () => {
                  const [, error] = await submitOTP(
                    location.state?.username,
                    location.state?.refCode,
                    otp
                  );
                  if (error) {
                    setErrorTextField(true);
                  } else {
                    setErrorTextField(false);
                    history.push({
                      pathname: "/reset-password",
                      state: {
                        maskedEmail: location.state?.maskedEmail,
                        refCode: location.state?.refCode,
                        username: location.state?.username,
                        otp: otp,
                      },
                    });
                  }
                }}
              >
                {translate("ra.action.confirm")}
              </Button>
              <Button
                className={classes.resendButton}
                onClick={async () => {
                  const [result] = await forgotPassword(
                    location.state.username
                  );
                  if (result) {
                    history.replace({
                      pathname: "/otp",
                      state: {
                        username: location.state.username,
                        refCode: result.payload.ref_code,
                        maskedEmail: result.payload.target,
                      },
                    });
                  }
                }}
              >
                {translate("ra.text.forgotPassword.resendOtp")}
              </Button>
            </Container>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default InputOTP;
